import Modal from '@/components/ui/Modal';
import SearchCitiesModalWebbed from '@/components/ui/SearchCitiesModalWebbed';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { faChevronLeft, faLocation, faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
const getTopVacations = (timeZone: string) => {
    const usaTimeZones = ["New_York"];
    const candaTimeZones = ["Toronto"];
    const ukTimeZones = ["London"];
    const euTimeZones = [
        "Berlin",
        "Madrid",
        "Paris",
        "Lisbon",
        "Rome",
        "Amsterdam",
        "Stockholm",
        "Athens",
        "Budapest",
    ];

    if (usaTimeZones.includes(timeZone)) {
        return [
            {
                country: "Mexico",
                cityName: "Cancún",
                id: "ChIJ21P2rgUrTI8Ris1fYjy3Ms4",
                image: 'https://assets.bamboo.travel' + "/cancun.jpg",
                lat: "21.161908",
                lng: "-86.8515279",
            },
            {
                cityName: "London",
                country: "United Kingdom",
                image: 'https://assets.bamboo.travel' + "/london.jpg",
                id: "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                lat: "51.5072178",
                lng: "-0.1275862",
            },
            {
                cityName: "Rome",
                country: "Italy",
                image: 'https://assets.bamboo.travel' + "/rome.jpg",
                id: "ChIJu46S-ZZhLxMROG5lkwZ3D7k",
                lat: "41.8967068",
                lng: "12.4822025",
            },
            {
                cityName: "Osaka",
                country: "Japan",
                image: 'https://assets.bamboo.travel' + "/osaka.jpg",
                id: "ChIJ4eIGNFXmAGAR5y9q5G7BW8U",
                lat: "34.6937249",
                lng: "135.5022535",
            },
            {
                cityName: "Paris",
                country: "France",
                image: 'https://assets.bamboo.travel' + "/paris.jpg",
                id: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                lat: "48.8575475",
                lng: "2.3513765",
            },
        ];
    } else if (candaTimeZones.includes(timeZone)) {
        return [
            {
                country: "United States",
                cityName: "New York",
                id: "ChIJOwg_06VPwokRYv534QaPC8g",
                image: 'https://assets.bamboo.travel' + "/new-york.jpg",
                lat: "40.7127753",
                lng: "-74.0059728",
            },
            {
                cityName: "Mexico City",
                country: "Mexico",
                image: 'https://assets.bamboo.travel' + "/mexico-city.jpg",
                id: "ChIJB3UJ2yYAzoURQeheJnYQBlQ",
                lat: "19.4326077",
                lng: "-99.133208",
            },
            {
                cityName: "Paris",
                country: "France",
                image: 'https://assets.bamboo.travel' + "/paris.jpg",
                id: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                lat: "48.8575475",
                lng: "2.3513765",
            },
            {
                cityName: "Havana",
                country: "Cuba",
                image: 'https://assets.bamboo.travel' + "/havana.jpg",
                id: "ChIJ4QD2vUx3zYgRYA13Gn5NKU4",
                lat: "23.1135925",
                lng: "-82.3665956",
            },
            {
                cityName: "London",
                country: "United Kingdom",
                image: 'https://assets.bamboo.travel' + "/london.jpg",
                id: "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                lat: "51.5072178",
                lng: "-0.1275862",
            },
        ];
    } else if (ukTimeZones.includes(timeZone)) {
        return [
            {
                cityName: "Madrid",
                country: "Spain",
                image: 'https://assets.bamboo.travel' + "/madrid.jpg",
                id: "ChIJgTwKgJcpQg0RaSKMYcHeNsQ",
                lat: "40.4167754",
                lng: "-3.7037902",
            },
            {
                cityName: "Athens Greece",
                country: "Greece",
                image: 'https://assets.bamboo.travel' + "/athens.jpg",
                id: "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                lat: "37.9838096",
                lng: "23.7275388",
            },
            {
                cityName: "Lisbon",
                country: "Portugal",
                image: 'https://assets.bamboo.travel' + "/listbon.jpg",
                id: "ChIJO_PkYRozGQ0R0DaQ5L3rAAQ",
                lat: "38.7222524",
                lng: "-9.1393366",
            },
            {
                cityName: "Paris",
                country: "France",
                image: 'https://assets.bamboo.travel' + "/paris.jpg",
                id: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                lat: "48.8575475",
                lng: "2.3513765",
            },
            {
                country: "United States",
                cityName: "New York",
                id: "ChIJOwg_06VPwokRYv534QaPC8g",
                image: 'https://assets.bamboo.travel' + "/new-york.jpg",
                lat: "40.7127753",
                lng: "-74.0059728",
            },
        ];
    } else if (euTimeZones.includes(timeZone)) {
        return [
            {
                country: "Turkiye",
                cityName: "Istunbul",
                id: "ChIJ21P2rgUrTI8Ris1fYjy3Ms4",
                image: 'https://assets.bamboo.travel' + "/istunbul.jpg",
                lat: "41.0082376",
                lng: "28.9783589",
            },
            {
                cityName: "London",
                country: "United Kingdom",
                image: 'https://assets.bamboo.travel' + "/london.jpg",
                id: "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                lat: "51.5072178",
                lng: "-0.1275862",
            },
            {
                cityName: "Zurich",
                country: "Switzerland",
                image: 'https://assets.bamboo.travel' + "/zurich.jpg",
                id: "ChIJGaK-SZcLkEcRA9wf5_GNbuY",
                lat: "47.3768866",
                lng: "8.541694",
            },
            {
                cityName: "Barcelona",
                country: "Spain",
                image: 'https://assets.bamboo.travel' + "/barcelona.jpg",
                id: "ChIJ5TCOcRaYpBIRCmZHTz37sEQ",
                lat: "41.3873974",
                lng: "2.168568",
            },
            {
                country: "United States",
                cityName: "New York",
                id: "ChIJOwg_06VPwokRYv534QaPC8g",
                image: 'https://assets.bamboo.travel' + "/new-york.jpg",
                lat: "40.7127753",
                lng: "-74.0059728",
            },
        ];
    } else {
        return [
            {
                country: "Mexico",
                cityName: "Cancún",
                id: "ChIJ21P2rgUrTI8Ris1fYjy3Ms4",
                image: 'https://assets.bamboo.travel' + "/cancun.jpg",

                lat: "21.161908",
                lng: "-86.8515279",
            },
            {
                cityName: "London",
                country: "United Kingdom",
                image: 'https://assets.bamboo.travel' + "/london.jpg",
                id: "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                lat: "51.5072178",
                lng: "-0.1275862",
            },
            {
                cityName: "Rome",
                country: "Italy",
                image: 'https://assets.bamboo.travel' + "/rome.jpg",
                id: "ChIJu46S-ZZhLxMROG5lkwZ3D7k",
                lat: "41.8967068",
                lng: "12.4822025",
            },
            {
                cityName: "Paris",
                country: "France",
                image: 'https://assets.bamboo.travel' + "/paris.jpg",
                id: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                lat: "48.8575475",
                lng: "2.3513765",
            },
            {
                cityName: "Barcelona",
                country: "Spain",
                image: 'https://assets.bamboo.travel' + "/barcelona.jpg",
                id: "ChIJ5TCOcRaYpBIRCmZHTz37sEQ",
                lat: "41.3873974",
                lng: "2.168568",
            },
        ];
    }
};

export default function MobileSearchInput({ hasError, setSelectedCity, selectedCity, onFocus, isHotelSearch }: {
    hasError?: boolean,
    onFocus?: () => void;
    setSelectedCity: Dispatch<SetStateAction<{
        name: string;
        id: string;
        country: string;
    }>>
    , selectedCity: {
        name: string;
        id: string;
        country: string;
    },
    isHotelSearch?: boolean
}) {
    const [cityError, setCityError] = useState(false);
    const [isGettingCities, setIsGettingCities] = useState(false);
    const [city, setCity] = useState("");
    const [showCities, setShowCities] = useState(false);
    const [fetchError, setFetchError] = useState("");
    const [predictions, setPredictions] = useState<
        { id: string; name: string }[]
    >([]);


    const { mainParams: { country } } = useSetSearchParams();
    const cityParam = country?.[1] || country?.[0]

    const cityModal = useOutsideClick(() => {
        setShowCities(false);
    });

    const get = async (city: string) => {
        setIsGettingCities(true);
        try {
            const res = await fetch(`/api/places?city=${city}`);

            const { data } = await res.json();

            const cityNames = data?.map(
                (prediction: { name: string; id: string }) => {
                    return {
                        name: prediction.name,
                        id: prediction.id,
                    };
                },
            );

            setIsGettingCities(false);
            setPredictions(cityNames || []);
        } catch (err) {
            setIsGettingCities(false);

            setFetchError("Something went wrong!");
        }
    };

    useEffect(() => {
        setFetchError("");
        if (city) {
            setIsGettingCities(true);
        }

        const getData = setTimeout(() => {
            if (city && city.length > 0) {
                get(city);
            }
        }, 400);

        return () => clearTimeout(getData);
    }, [city]);

    useEffect(() => {
        if (cityParam) {
            setCity(cityParam as string);
        }
    }, [cityParam]);

    useEffect(() => {
        if (selectedCity.name) {
            setCity(selectedCity.name)
        }
    }, [selectedCity.name])

    const inputRef = useRef<HTMLInputElement>(null);

    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        // Focus the input only when the modal is shown
        if (showModal && inputRef.current) {
            inputRef.current.focus();
        }
    }, [showModal]); // Re-run the 

    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const data = getTopVacations(userTimezone.split("/")[1]);

    const handleClose = () => {
        if (cityModal.current) {
            cityModal.current.click();
        }
        setShowModal(false)
    }


    return (
        <>
            {!isHotelSearch && <Modal isFull identifier='citySearch' onClose={handleClose} show={showModal}
            >
                <div className='w-full overflow-y-auto relative'>

                    <div className='w-full pb-4 border-b grid gap-2 items-center grid-cols-[auto,_1fr]'>
                        <button className='p-1' onClick={handleClose}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <div className='relative'>
                            <button
                                onClick={() => {
                                    setSelectedCity({
                                        name: "",
                                        id: "",
                                        country: "",
                                    });
                                    setCity('')
                                }}
                                className='p-1 absolute top-1/2 text-sm  right-2 -translate-y-1/2'>
                                <FontAwesomeIcon icon={faX} className='text-indigo-500' size='xs' />
                            </button>
                            <input
                                ref={inputRef}
                                value={
                                    city + (selectedCity.country ? `, ${selectedCity.country}` : "")
                                }
                                onChange={async (e) => {
                                    setShowCities(true)
                                    setCity(e.target.value);
                                    setSelectedCity({
                                        name: "",
                                        id: "",
                                        country: "",
                                    });
                                }}
                                placeholder='Where to?'
                                className='px-3.5 py-2.5 w-full text-sm text-neutral-700 placeholder:text-neutral-500 rounded-full
                                            placeholder:text-xs bg-white border focus:border-neutral-200 focus:ring-0 focus:outline-none'
                            />
                        </div>

                    </div>
                    {/* <div className='py-4 grid grid-cols-[56px,_1fr] gap-2'>
                        <div className='aspect-square w-full rounded-lg bg-neutral-100 flex items-center justify-center'>
                            <FontAwesomeIcon icon={faLocationArrow} className='text-neutral-500' />
                        </div>
                        <div className='flex items-center text-sm text-neutral-800 justify-start'>
                            Hotels nearby
                        </div>
                    </div> */}
                    <div className='relative'>
                        <div className=' overflow-y-auto'>
                            <div className='mt-4 relative z-10 pb-6'>

                                <div className='text-xs font-normal text-neutral-700'>Popular destinations</div>
                                <div className='mt-3 flex flex-col gap-3 relative z-10'>
                                    {isGettingCities && city.length > 0 ? (

                                        <div className="flex w-full flex-col gap-8 pt-1">
                                            <div className="grid-cols-[56px,_1fr] gap-2 grid">
                                                <div className="aspect-square w-full animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                                                <div className="flex flex-col gap-2 justify-between">
                                                    <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                                    <div className="h-3 w-14 animate-pulse rounded bg-slate-200 "></div>
                                                </div>
                                            </div>
                                            <div className="grid-cols-[56px,_1fr] gap-2 grid">
                                                <div className="aspect-square w-full animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                                                <div className="flex flex-col gap-2 justify-between">
                                                    <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                                    <div className="h-3 w-14 animate-pulse rounded bg-slate-200 "></div>
                                                </div>
                                            </div>
                                            <div className="grid-cols-[56px,_1fr] gap-2 grid">
                                                <div className="aspect-square w-full animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                                                <div className="flex flex-col gap-2 justify-between">
                                                    <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                                    <div className="h-3 w-14 animate-pulse rounded bg-slate-200 "></div>
                                                </div>
                                            </div>
                                            <div className="grid-cols-[56px,_1fr] gap-2 grid">
                                                <div className="aspect-square w-full animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                                                <div className="flex flex-col gap-2 justify-between">
                                                    <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                                    <div className="h-3 w-14 animate-pulse rounded bg-slate-200 "></div>
                                                </div>
                                            </div>
                                            <div className="grid-cols-[56px,_1fr] gap-2 grid">
                                                <div className="aspect-square w-full animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                                                <div className="flex flex-col gap-2 justify-between">
                                                    <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                                    <div className="h-3 w-14 animate-pulse rounded bg-slate-200 "></div>
                                                </div>
                                            </div>
                                        </div>

                                    ) : predictions.length > 0 && city.length > 0 ? (

                                        predictions?.map((item) => (
                                            <div
                                                onTouchEnd={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    setShowCities(false);
                                                    setCityError(false);
                                                    handleClose()
                                                    setSelectedCity({
                                                        name: item.name.split(",")[0],
                                                        id: item.id,
                                                        country:
                                                            item.name.split(", ")[item.name.split(", ").length - 1],
                                                    });
                                                    setCity(item.name.split(",")[0]);
                                                }}
                                                className="group grid cursor-pointer grid-cols-[56px,_1fr] gap-2 place-items-start items-start rounded-xl 
                                                 px-1 py-2 transition-colors duration-200 hover:bg-gray-100 hover:text-emerald-700 lg:w-full"
                                                key={item.id}
                                            >
                                                <div className='flex items-center justify-center w-full h-full'>
                                                    <FontAwesomeIcon icon={faLocation} className="w-5 justify-self-center text-gray-600" />
                                                </div>
                                                <div className="flex flex-col  gap-1">
                                                    <p className="font-semibold text-sm text-neutral-800">
                                                        {" "}
                                                        {item.name.split(", ")[0]}{" "}
                                                    </p>
                                                    <span className="text-xs font-normal text-gray-600">
                                                        {item.name.split(", ")[1] !== item.name.split(", ")[item.name.split(", ").length - 1] && item.name.split(", ")[1]}{" "}{item.name.split(", ")[item.name.split(", ").length - 1]}{" "}
                                                    </span>
                                                </div>
                                            </div>
                                        ))

                                    ) : (
                                        city.length > 0 ? (

                                            <div
                                                className="group flex w-full max-w-full cursor-pointer items-center gap-3 
                          transition-colors duration-200 hover:text-emerald-700 "
                                            >
                                                {fetchError ? (
                                                    <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                                        <p className="text-orange-500">{fetchError}</p>

                                                        <Image
                                                            className="w-32"
                                                            src={"https://assets.bamboo.travel/wrong.svg"}
                                                            width={300}
                                                            height={300}
                                                            alt="Nothing Found"
                                                        />
                                                    </div>
                                                ) : (
                                                    city.length > 0 && (
                                                        <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                                            <p className='text-neutral-700 text-sm'>nothing was found!</p>

                                                            <Image
                                                                className="w-16"
                                                                src={"https://assets.bamboo.travel/looking.svg"}
                                                                width={300}
                                                                height={300}
                                                                alt="Nothing Found"
                                                            />
                                                        </div>
                                                    )
                                                )}
                                            </div>

                                        ) : data.map(item => <div
                                            key={item.id}
                                            onTouchEnd={(event) => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                setSelectedCity({
                                                    name: item.cityName,
                                                    id: item.id,
                                                    country:
                                                        item.country,
                                                });
                                                setCity(item.cityName);
                                                handleClose()
                                            }}


                                            className=' grid grid-cols-[56px,_1fr] gap-2'>
                                            <div className='aspect-square w-full relative overflow-hidden rounded-lg bg-neutral-100 flex items-center justify-center'>
                                                <Image className='object-cover w-full h-full' width={100} height={100} src={item.image} alt='city' />
                                            </div>
                                            <div className='flex flex-col  text-sm text-neutral-800 justify-between'>
                                                <span className='font-semibold'> {item.cityName}</span>
                                                <span className='text-xs font-normal'>{item.country}</span>
                                            </div>
                                        </div>)
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>}
            <input
                readOnly
                ref={cityModal}
                placeholder={'Find destination'}
                value={
                    city + (selectedCity.country ? `, ${selectedCity.country}` : "")
                }
                className={`${hasError ? "border-rose-500" : "border"} md:hidden 
                   peer relative capitalize border-0 h-full w-full pl-0 pr-2.5 py-1 text-neutral-800 font-normal
                    placeholder:text-neutral-500 placeholder:font-normal placeholder:text-sm 
             `}
                onChange={async (e) => {
                    setShowCities(true)
                    setCity(e.target.value);
                    setSelectedCity({
                        name: "",
                        id: "",
                        country: "",
                    });
                }}
                onClick={() => {
                    setShowCities(true)
                    setShowModal(true)
                }}
                onFocus={() => {
                    onFocus && onFocus()
                    setShowModal(true)
                    setShowCities(true);
                }}
                type="text"
            />
            {cityError && (
                <p className="ps-1 pt-1 text-sm font-normal text-red-600">
                    Please choose your destination.
                </p>
            )}

            {isHotelSearch && <SearchCitiesModalWebbed
                showModal={showModal}
                setShowModal={setShowModal}
                onFocus={onFocus}
                hasError={hasError}
                setSelectedCity={setSelectedCity}
                selectedCity={selectedCity}
            />}
        </>
    );
}